import React from 'react';
import { useAdobeDataLayer, PageNames } from '../../../hooks/useAdobeDataLayer';
import OffsiteDigitalHero from '../../../components/Redesign/OffsiteDigitalHero';
import Intro from '../../../components/Redesign/Intro';
import MediaFeatureSection from '../../../components/Redesign/MediaFeatureSection';
import offsiteDigitalSections from '../../../components/Redesign/offsiteDigitalSections';
import ContactBanner from '../../../components/Redesign/ContactBanner';
import brandJourneyAvif from 'url:../../../assets-optimized/redesign/solutions/offsite-digital/brandJourney.avif';
import brandJourneyWebp from 'url:../../../assets-optimized/redesign/solutions/offsite-digital/brandJourney.webp';
import brandJourneyBg from 'url:../../../assets-optimized/redesign/solutions/offsite-digital/brandJourney.png';
import SolutionsNavigation from '../../../components/Redesign/SolutionsNavigation';
import './OffsiteDigital.css';

const OffsiteDigital = () => {
    const { sendPageView } = useAdobeDataLayer();

    React.useEffect(() => {
        sendPageView(PageNames.OffsiteDigital);
    }, [sendPageView]);

    return (
        <div className='offsite-digital-page'>
            <OffsiteDigitalHero />

            <Intro className="intro-custom-size">
                Reach travelers before they arrive and after they leave.<br className="desktop-only" /> This keeps your brand<br className="mobile-only" /> connected to the{' '}
                <span className='audience-pill cs-intro-pill' style={{ '--pill-bg': '#DDF4FF' }}>
                    <span className='cs-lightning-wrapper' style={{ backgroundColor: '#29ABE2' }}>
                        <svg viewBox="0 0 24 24" className="cs-lightning-bolt" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                        </svg>
                    </span>
                    full arc of travel recall and appreciation.
                </span>
            </Intro>

            {offsiteDigitalSections.map((section) => (
                <MediaFeatureSection key={section.id} {...section} />
            ))}
            <ContactBanner className="contact-banner-alt" title="Bring your brand into the journey" bgImage={brandJourneyBg} bgImageAvif={brandJourneyAvif} bgImageWebp={brandJourneyWebp} />

            <SolutionsNavigation
                prevTitle="ON PROPERTY"
                prevLink="/solutions/on-property"
                nextTitle="MARRIOTT DIGITAL"
                nextLink="/solutions/marriott-digital"
            />
        </div>
    );
};

export default OffsiteDigital;

